export enum ClientSettingsOption {
  PickupTimeOffsetMinutes = 'PUTIMEOFFSETMINUTES',
}
export interface ClientSettingOption {
  clientSettingOptionID: number;
  clientSettingOptionName: string;
  description: string;
  clientSettingOptionBC: string;
  isActive: boolean;
}
export interface ClientSetting {
  clientSettingID?: number;
  clientSettingOptionID: number;
  clientSettingValue: number;
  effectiveStartDate: string;
  effectiveEndDate: string | null;
  clientSettingState: string;
  clientSettingOptionBC: string;
}
